import CurrentCountry from '@phoenix/components/CurrentCountry';
import GeoLoc from '@maison/components/GeoLoc';
import createVueApp from '@phoenix/createVueApp';
import { defineAsyncComponent } from 'vue';
import { CURRENT_COUNTRY_CHANGED, emitter } from '@phoenix/event-bus';

const currentCountry = new CurrentCountry();
new GeoLoc(currentCountry);

Object.assign(window, {
  currentCountry,
  GeoLoc,
});

document.querySelectorAll('.drawer-localisation').forEach((el) => {
  el.addEventListener('click', () => {
    emitter.on(CURRENT_COUNTRY_CHANGED, () => window.location.reload());
  });
});

if (document.getElementById('phoenix-cart-panel')) {
  const app = createVueApp({}, true);
  app.component(
    'CartPanel',
    defineAsyncComponent(() => import('@maison/components/checkout/summary/CartPanel.vue')),
  );
  app.mount('#phoenix-cart-panel');
}

if (document.getElementById('phoenix-wishlist-panel')) {
  const app = createVueApp({}, true);
  app.component(
    'WishlistPanel',
    defineAsyncComponent(() => import('@maison/components/wishlist/WishlistPanel.vue')),
  );
  app.mount('#phoenix-wishlist-panel');
}

if (document.getElementById('phoenix-account-panel')) {
  const app = createVueApp({}, true);
  app.component(
    'AccountPanel',
    defineAsyncComponent(() => import('@maison/components/myAccount/panel/AccountPanel.vue')),
  );
  app.mount('#phoenix-account-panel');
}

if (document.getElementById('phoenix-wishlist-icon')) {
  const app = createVueApp({}, true);
  app.component(
    'WishlistIcon',
    defineAsyncComponent(() => import('../components/wishlist/WishlistIcon.vue')),
  );
  app.mount('#phoenix-wishlist-icon');
}

if (document.getElementById('phoenix-cart-icon')) {
  const app = createVueApp({}, true);
  app.component(
    'CartIcon',
    defineAsyncComponent(() => import('../components/checkout/summary/CartIcon.vue')),
  );
  app.mount('#phoenix-cart-icon');
}
